import { Dialog, DialogContent, DialogContentText, Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { authLogout } from '../../auth/authSlice';
import { formatarNumeroFamiliar } from '../../common/formatadores';
import Card from '../../components/Card/Card';
import FieldGroup from '../../components/FieldGroup/FieldGroup';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import styles from './ConsultaPendencias.module.css';
import { getPendenciasOcorrenciasFamilia, getPendenciasOcorrenciasFamiliaRL, selectPendenciaOcorrencia } from './consultaPendenciasSlice';
import Accordion from '../../components/Accordion/Accordion';
import configuration from '../../envConfig';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import { selectLoadingCount } from '../../globalSlice';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { obterNomeOuNomeSocial } from '../../common/integranteUtils';
import { trackServiceSelect } from '../../common/tracker';

export const SCROLL_OFFSET_NAV_FIXED = configuration.isCordova ? -80 : -150;

const ConsultaPendencias: React.FC<any> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const pendenciaOcorrencia = useAppSelector(selectPendenciaOcorrencia);

  const [infoAdicionalOpen, setInfoAdicionalOpen] = useState(false);
  const [infoAdicionalSelecionada, setInfoAdicionalSelecionada] = useState('');

  const loadingCount = useAppSelector(selectLoadingCount);

  useEffect(() => {
    if (perfil?.tipoPerfil?.codigo === 2) {
      dispatch(getPendenciasOcorrenciasFamiliaRL({
        idRL: perfil?.identificador,
        numeroFamiliar: perfil?.numeroFamiliar
      }));
    } else {
      dispatch(getPendenciasOcorrenciasFamilia({
        idPessoa: perfil?.identificador,
        numeroFamiliar: perfil?.numeroFamiliar
      }));
    }
  }, [dispatch, perfil?.tipoPerfil?.codigo, perfil?.identificador, perfil?.numeroFamiliar]);

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const mostrarParentesco = (tipoRelacaoParentescoRF: any) => {
    if (tipoRelacaoParentescoRF?.nome === 'Pessoa Responsável pela Unidade Familiar - RF') {
      return 'Responsável Familiar - RF';
    }
    return tipoRelacaoParentescoRF?.nome;
  };

  const mostrarPendencia = (pendencia: any, index: number) => {
    return (
      <>
        <div key={index} className={styles.pendenciaWrapper}>
          <i className={`fas fa-exclamation-triangle ${styles.pendenciaIcon}`}></i>
          <div className={styles.pendenciaText}>
            <span dangerouslySetInnerHTML={{ __html: pendencia.descricaoFormatada }}></span>
            {pendencia.informacaoAdicionalFormatada && (
              <i
                className={`fas fa-info-circle ${styles.iconInfoAdicional}`}
                onClick={() => {
                  setInfoAdicionalSelecionada(pendencia.informacaoAdicionalFormatada);
                  setInfoAdicionalOpen(true);
                }}
              />
            )}
          </div>
        </div>
      </>
    )
  };

  return (
    <MainContainer
      userNav={true}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={'Pendências do cadastro'}
      barraAuxiliar={true}
      stoppedTitle={true}
      navFixed
      navSeparator
      navCaixaMensagens={caixaMensagens}
      navLogout={logout}
    >
      <div className={styles.container}>
        {pendenciaOcorrencia?.quantidadePendencias === 0 && (
          <Message
            type="info"
            className={styles.message}
            text="Não foram encontradas pendências para essa família."
          />
        )}

        {!!pendenciaOcorrencia?.quantidadePendencias &&
          pendenciaOcorrencia?.quantidadePendencias > 0 && (
            <>
              <Message
                type="error"
                className={styles.message}
                title="ATENÇÃO!"
                text={`
                  O responsável familiar deve comparecer a um CRAS ou posto de atendimento
                  para verificar as pendências registradas.
                `}
              />

              <div className={styles.cardHeader}>
                <i className={`fas fa-users ${styles.cardIcon}`}></i>
                <span className={styles.cardTitle}>Pendências da família</span>
              </div>

              {(!pendenciaOcorrencia?.pendenciasOcorrenciasFamilia ||
                pendenciaOcorrencia?.pendenciasOcorrenciasFamilia.length === 0) && (
                  <Message
                    type="info"
                    className={styles.message}
                    text="Não foram encontradas pendências para a família no cadastro."
                  />
              )}

              {pendenciaOcorrencia?.pendenciasOcorrenciasFamilia &&
                pendenciaOcorrencia?.pendenciasOcorrenciasFamilia.length > 0 && (
                  <Card>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FieldGroup
                          label="Código familiar"
                          value={formatarNumeroFamiliar(perfil?.numeroFamiliar)}
                        />
                      </Grid>
                      {pendenciaOcorrencia?.pendenciasOcorrenciasFamilia &&
                        pendenciaOcorrencia?.pendenciasOcorrenciasFamilia.map((pendencia, index) => {
                          return (
                            <Grid item xs={12}>
                              {mostrarPendencia(pendencia, index)}
                            </Grid>
                          );
                        })}
                    </Grid>
                  </Card>
              )}

              <div className={styles.cardHeader}>
                <i className={`fas fa-user ${styles.cardIcon}`}></i>
                <span className={styles.cardTitle}>Pendências dos integrantes</span>
              </div>

              {(!pendenciaOcorrencia?.pendenciasOcorrenciasPessoas ||
                pendenciaOcorrencia?.pendenciasOcorrenciasPessoas.length === 0) && (
                  <Message
                    type="info"
                    className={styles.message}
                    text="Não foram encontradas pendências para os integrantes desta família."
                  />
              )}

              {pendenciaOcorrencia?.pendenciasOcorrenciasPessoas &&
                pendenciaOcorrencia?.pendenciasOcorrenciasPessoas.length > 0 &&
                pendenciaOcorrencia?.pendenciasOcorrenciasPessoas.map((integrante, index) => {
                  return (
                    <Accordion
                      id={`pendencia-integrante-${index}`}
                      title={obterNomeOuNomeSocial(integrante)}
                      subtitle={mostrarParentesco(integrante.tipoRelacaoParentescoRF)}
                      exibirSubtitulo
                      key={index}
                      alwaysOpen
                    >
                      <Grid container spacing={2}>
                        {integrante.pendenciasOcorrenciasPessoa &&
                          integrante.pendenciasOcorrenciasPessoa.map((pendencia, i) => {
                            return (
                              <Grid item xs={12}>
                                {mostrarPendencia(pendencia, i)}
                              </Grid>
                            );
                          })}
                      </Grid>
                    </Accordion>
                  );
                })
              }
            </>
        )}

        {loadingCount == 0 &&
          <AjudaRapida scrollOffset={SCROLL_OFFSET_NAV_FIXED}>
            <div className={styles.textoAjudaRapida}>
              <strong>Pendências</strong>
              <br />
              <br />
              Aqui você pode consultar se existem pendências no cadastro da família e dos integrantes. Essas pendências são informações do cadastro que precisam ser corrigidas ou atualizadas.
              <br />
              <br />
              <br />
              <strong>Pendências da família</strong>
              <br />
              <br />
              Aqui é possível identificar as pendências, informações que precisam ser corrigidas ou atualizadas no cadastro da sua família.
              <br />
              <br />
              <br />
              <strong>Pendências dos integrantes</strong>
              <br />
              <br />
              Aqui é possível consultar as pendências, informações que precisam ser corrigidas ou atualizadas no cadastro dos integrantes da sua família.
              <br />
              <br />
            </div>
          </AjudaRapida>
        }

        <Dialog open={infoAdicionalOpen} onClose={() => setInfoAdicionalOpen(false)}>
          <DialogContent>
            <DialogContentText>
              <span
                className={styles.infoAdicinoalText}
                dangerouslySetInnerHTML={{ __html: infoAdicionalSelecionada }}>
              </span>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    </MainContainer>
  );
};

export default ConsultaPendencias;
